import * as React from "react";
import { Book } from "../../types/Book";
import { useParams } from "react-router-dom";
import getBook from "../../requests/getBook";
import "./BookPage.css";
import { LibraryCard } from "../../types/LibraryCard";
import getLibraryCard from "../../requests/getLibraryCard";
import Dialog from "@material-ui/core/Dialog";
import EditBookCard from "../EditBookCard/EditBookCard";
import Inner from "../Feed/Card/CardDetails/Inner/Inner";
import { CardsManagerCallbacks } from "../CardsManager/CardsManager";
import OtherBooks from "./OtherBooks/OtherBooks";
import { Helmet } from 'react-helmet';
import AdBlock from "../AdBlock/AdBlock";

interface Props {
	callbacks: CardsManagerCallbacks;
}

const BookPage: React.FunctionComponent<Props> = (props) => {
	const [isLoading, setLoading] = React.useState(false);
	const [book, setBook] = React.useState<Book>();
	const [libraryInfo, setLibraryInfo] = React.useState<LibraryCard>(null);
	const [editBookOpen, setEditBookOpen] = React.useState(false);

	const showEditBookPopup = () => setEditBookOpen(true);
	const hideEditBookPopup = () => setEditBookOpen(false);

	const { id } = useParams<{ id: string }>();

	React.useEffect(() => {
		setLoading(true);

		window.scrollTo({
			top: 0
		});

		const request = async () => {
			const data = await getBook(id, true);

			setLoading(false);

			if (data && data.externalId) {
				setBook(data);

				if (data.cardId) {
					const library = await getLibraryCard(data.cardId);

					if (library) {
						setLibraryInfo(library);
					}
				}
			}
		};

		request();
	}, [id]);

	return (
		<div className="bookPage">
			<div className="bookPage__wrapper">
				{book && (
					<>
						<Helmet>
							<title>
								{book.author}. {book.name} - Readed.me
							</title>
						</Helmet>

						<div className="bookPage__bookBackground">
							<div className="miniBook__wrapper">
								<Inner
									book={book}
									onClose={() => window.history.back()}
									className="bookPage__inner"
									callbacks={props.callbacks}
								/>

								<div style={{ marginTop: '15px' }}>
									<AdBlock />
								</div>
							</div>
						</div>

						<OtherBooks bookId={book.woo_id} />
					</>
				)}

				{isLoading && <div className="bookPage__loading">Загрузка...</div>}

				{!isLoading && !book && (
					<div className="bookPage__loading">
						😰
						<p>Ой, что-то пошло не так (</p>
					</div>
				)}
			</div>

			<Dialog maxWidth="md" open={editBookOpen} onClose={hideEditBookPopup}>
				<EditBookCard
					book={book}
					onSaved={() => {
						window.location.reload();
					}}
					libraryCard={libraryInfo}
					saveCard={props.callbacks.addCard}
					saveProperties={props.callbacks.saveCardProperties}
				/>
			</Dialog>
		</div>
	);
};

export default BookPage;
